class VerellaAnnouncement extends HTMLElement {
  connectedCallback() {
    this.messages = [...this.querySelectorAll('[data-announcement-message]')];
    this.currentIndex = Math.max(
      0,
      this.messages.findIndex((message) => message.classList.contains('is-active'))
    );
    this.interval = Math.max(Number(this.dataset.interval) || 6000, 3000);
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.handleVisibility = () => (document.hidden ? this.stop() : this.start());
    this.addEventListener('pointerenter', this.stop);
    this.addEventListener('pointerleave', this.start);
    this.addEventListener('focusin', this.stop);
    this.addEventListener('focusout', this.start);
    document.addEventListener('visibilitychange', this.handleVisibility);

    this.start();
  }

  disconnectedCallback() {
    this.stop();
    this.removeEventListener('pointerenter', this.stop);
    this.removeEventListener('pointerleave', this.start);
    this.removeEventListener('focusin', this.stop);
    this.removeEventListener('focusout', this.start);
    document.removeEventListener('visibilitychange', this.handleVisibility);
  }

  start = () => {
    this.stop();
    if (this.messages.length < 2 || document.hidden) return;
    this.timer = window.setInterval(() => this.showNext(), this.interval);
  };

  stop = () => {
    if (!this.timer) return;
    window.clearInterval(this.timer);
    this.timer = undefined;
  };

  showNext() {
    const previous = this.messages[this.currentIndex];
    const nextIndex = (this.currentIndex + 1) % this.messages.length;
    const next = this.messages[nextIndex];

    previous.classList.remove('is-active');
    previous.classList.add('is-leaving');
    previous.setAttribute('aria-hidden', 'true');

    next.classList.remove('is-leaving');
    next.classList.add('is-active');
    next.setAttribute('aria-hidden', 'false');

    const cleanupDelay = this.reducedMotion.matches ? 0 : 650;
    window.setTimeout(() => previous.classList.remove('is-leaving'), cleanupDelay);
    this.currentIndex = nextIndex;
  }
}

if (!customElements.get('verella-announcement')) {
  customElements.define('verella-announcement', VerellaAnnouncement);
}
